<template>
	<div class="card class-feature mb-2">
		<div class="card-body p-0">
			<div class="input-group">
				<input type="text" class="form-control" v-model="trait.name"/>
				<div class="input-group-append">
					<button type="button" class="btn btn-danger" @click="removeTrait()">&times;</button>
				</div>
			</div>
			<textarea class="form-control auto-expand" v-model="trait.description"></textarea>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'index',
		'trait'
	],
	methods: {
		removeTrait() {
			this.$store.commit('character/race/removeTrait',this.index)
		}
	},
	watch: {
		trait: {
			deep: true,
			handler: function(){
				this.$store.commit('character/race/updateTrait',{
					index: this.index,
					value: this.trait,
				})
			}
		}
	}
}
</script>

<style scoped>
input {
	border: transparent 0px;
}
textarea {
	border-left: transparent 0px;
	border-right: transparent 0px;
	border-bottom: transparent 0px;
	border-radius: 0px;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
}
</style>